import { IBlockUser, IPayDebt } from "../../../types/common.interface";
import customAxios from "../../customAxios";
import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const payDebtByAdmin = async (props: IPayDebt) => {
  const body = {
    fishId: props.fishId,
    paidDate: props.paidDate,
    paymentType: props.paymentType,
  };

  try {
    return (
      await customAxios.put(PAY_DEBT_BY_ADMIN_PUT + `/${props.debtId}`, body)
    ).data;
  } catch (error: unknown) {
    console.error({ UPDATE_ADMIN: error });
    return false;
  }
};

export default payDebtByAdmin;
